import { render, staticRenderFns } from "./PresentationNews.vue?vue&type=template&id=70754098&scoped=true&name=presentation-news&"
import script from "./PresentationNews.vue?vue&type=script&lang=js&"
export * from "./PresentationNews.vue?vue&type=script&lang=js&"
import style0 from "./PresentationNews.vue?vue&type=style&index=0&id=70754098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70754098",
  null
  
)

export default component.exports